import * as React from 'react';
import { Img } from 'react-image';

import { Button } from '../button';

export const Error = ({
  title = 'Houston, we have a problem!',
  subTitle = 'Something went wrong while fetching this page. Refresh the page or try again later',
  image = 'https://res.cloudinary.com/samvibes/image/upload/houston_error.png',
  onHandle,
  handleTxt = 'Go back',
}: {
  title?: string;
  subTitle?: string;
  image?: string;
  onHandle?: () => void;
  handleTxt?: string;
}) => {
  return (
    <div className="flex justify-center items-center flex-col text-center w-full h-full">
      <Img className="max-w-467" src={image} />
      <p style={{ maxWidth: '69rem' }} className="mb-12 text-5xl text-blue-800 font-bold ">
        {title}
      </p>
      <p style={{ maxWidth: '56rem' }} className="mb-42 text-blue-500 max-w-550 text-xl font-bold">
        {subTitle}
      </p>
      <Button size="lg" onClick={onHandle}>
        {handleTxt}
      </Button>
    </div>
  );
};
